import { Injectable, inject } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { from, Observable } from "rxjs";
import { ProduktionsomradeDetailComponent } from "./produktionsomrade-detail.component";

@Injectable({
    providedIn: "root"
})
export class ProduktionsomradeDetailDialogService {
    private readonly ngbModalService = inject(NgbModal);

    produktionsomradeDetailModal(id: number): Observable<any> {
        if (!this.ngbModalService.hasOpenModals()) {
            const modalRef = this.ngbModalService.open(ProduktionsomradeDetailComponent, {
                keyboard: false,
                backdrop: "static",
                size: "xl"
            });
            const modal = modalRef.componentInstance as ProduktionsomradeDetailComponent;
            modal.isModalActive = true;
            modal.id = id;
            return from(modalRef.result);
        }

        return from(null);
    }
}
